import { Component, input, InputSignal } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  imports: [RouterLink],
  styleUrl: './back-button.component.scss'
})
export class BackButtonComponent {
  backLink: InputSignal<string> = input<string>('../');
}
